// Lib
import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Styles
import { useStyles } from './ToggleButtonStyles';

const ToggleButton = ({
  onToggle,
  open,
  UpElement,
  DownElement,
  className,
}) => {
  const { classes, cx } = useStyles({ open });

  const Up = useMemo(
    () => (UpElement ? UpElement : <ArrowDropUpIcon color="#54565B" />),
    [UpElement],
  );
  const Down = useMemo(
    () => (DownElement ? DownElement : <ArrowDropDownIcon color="#54565B" />),
    [DownElement],
  );

  return (
    <Button
      id="toggle-button"
      onClick={onToggle}
      className={cx(className, classes.button)}>
      {open ? Up : Down}
    </Button>
  );
};

export default ToggleButton;
